export type FaxDirection = 'inbound' | 'outbound';

export type SentFaxStatus = 'processing' | 'delivered' | 'cancelled' | 'failed' | 'chargeback' | 'refunded' | 'paid';

// {
//     "errorInfo": null,
//     "resultInfo": "OK",
//     "processingStatusName": "success",
//     "classificationLabel": "inbound",
//     "messageId": "f7b2cc2c-db2f-4116-a906-85ce2b940e86",
//     "deliveryId": null,
//     "watermark": null,
//     "messageNumber": null,
//     "status": "success",
//     "pagesCount": 1,
//     "pagesComplete": 1,
//     "duration": 10000,
//     "faxNumber": "+18447990365",
//     "faxCsid": "mFax",
//     "faxReceiverCsid": null,
//     "faxCallerId": "18447990365",
//     "faxECM": 1,
//     "faxSpeed": 35000,
//     "faxDetected": true,
//     "faxProtocol": 3,
//     "faxAttempt": 1,
//     "direction": "inbound",
//     "channelType": "web",
//     "recipientName": null,
//     "subject": null,
//     "deviceId": null,
//     "faxbridgeId": null,
//     "accountId": "9669c771-6c54-4ecc-9a3b-1afc90f7181b",
//     "errorCode": "0",
//     "resultCode": "0",
//     "isArchived": false,
//     "isFilePurged": false,
//     "country": "US",
//     "createdAt": "2026-02-21T00:20:44.000Z",
//     "readyAt": null,
//     "resolvedDate": "2026-02-21T00:21:00.000Z",
//     "deletedAt": null,
//     "users": [
//       {
//         "avatarPath": null,
//         "userId": "f3d02cad-f2d3-4b8c-b873-095e1e5a342c",
//         "uuid": "f3d02cad-f2d3-4b8c-b873-095e1e5a342c",
//         "email": "guorui.su@helloklarity.com",
//         "firstName": "Guorui",
//         "lastName": "Su",
//         "accountId": "9669c771-6c54-4ecc-9a3b-1afc90f7181b",
//         "avatar": null,
//         "uf": {
//           "viewStatus": true,
//           "downloadStatus": true
//         }
//       }
//     ],
//     "faxbridge": null,
//     "cf": {

//     },
//     "device": null,
//     "scheduledTo": null
//   }

export interface FaxHistoryItem {
    errorInfo: string | null;
    resultInfo: string;
    processingStatusName: string;
    classificationLabel: string;
    messageId: string;
    deliveryId: string | null;
    watermark: string | null;
    messageNumber: string | null;
    status: string;
    pagesCount: number;
    pagesComplete: number;
    duration: number;
    faxNumber: string;
    faxCsid: string;
    faxReceiverCsid: string | null;
    faxCallerId: string;
    faxECM: number;
    faxSpeed: number;
    faxDetected: boolean;
    faxProtocol: number;
    faxAttempt: number;
    direction: FaxDirection;
    channelType: string;
    recipientName: string | null;
    subject: string | null;
    deviceId: string | null;
    faxbridgeId: string | null;
    accountId: string;
    errorCode: string;
    resultCode: string;
    isArchived: boolean;
    isFilePurged: boolean;
    country: string;
    createdAt: string;
    readyAt: string | null;
    resolvedDate: string;
    deletedAt: string | null;
    users: {
        avatarPath: string | null;
        userId: string;
        uuid: string;
        email: string;
        firstName: string;
        lastName: string;
        accountId: string;
        avatar: string | null;
        uf: {
            viewStatus: boolean;
            downloadStatus: boolean;
        };
    }[];
    faxbridge: any | null;
    cf: Record<string, any>;
    device: any | null;
    scheduledTo: string | null;
    //todo 额外添加字段
    tag?: string;
    aiSummary?: string;
    patient?: string;
}

export interface SentFaxItem {
    id: string;
    messageId: string;
    sentTo: string;
    contactName?: string;
    subject?: string;
    status: SentFaxStatus;
    tag?: string;
    patient?: string;
    patientId?: string;
    sentOn: string;
}

export interface FaxContact {
    id: string;
    name: string;
    faxNumber: string;
    /** From server (e.g. formatted display); optional for local-only rows */
    faxNumberDisplay?: string;
    notes?: string;
    tag?: string;
    createAt?: string;
}

/** POST /fax/contact (gateway: /schedule-server/fax/contact) — OpenAPI FaxContactReq */
export interface TFaxContactCreateReq {
    faxNumber?: string;
    isFavorite?: boolean;
    name?: string;
    notes?: string;
    tag?: string[];
}

/** Alias matching backend schema name */
export type FaxContactReq = TFaxContactCreateReq;

/** POST /schedule-server/fax/contact/list — request body (OpenAPI: 基础翻页 + filters) */
export interface TFaxContactListQuery {
    /** Page index, 1-based */
    current?: number;
    name?: string;
    /** Fax number filter (API field name `number`) */
    number?: string;
    orderKey?: string;
    orderType?: string;
    size?: number;
    tag?: string[];
}

/** R«FaxContactVo» data field */
export interface FaxContactVo {
    id: number;
    documoContactId?: string;
    faxNumber: string;
    faxNumberDisplay?: string;
    name?: string;
    notes?: string;
    tag?: string[];
    isFavorite?: boolean;
    createAt?: string;
    updateAt?: string;
}

/** Page«FaxContactVo» in R«Page«FaxContactVo»» */
export interface TFaxContactListPage {
    countId?: string | null;
    current?: number;
    maxLimit?: number;
    optimizeCountSql?: boolean;
    orders?: { asc?: boolean; column?: string }[];
    pages?: number;
    records?: FaxContactVo[];
    searchCount?: boolean;
    size?: number;
    total?: number;
}

/** POST /fax/cover-page-template (gateway: /schedule-server/fax/cover-page-template) */
export interface TFaxCoverPageTemplateReq {
    /** Documo cover page UUID */
    documoCoverpageId?: string;
    /** whether default template */
    isDefault?: boolean;
    /** default note content */
    note?: string;
    /** cover page preview link */
    previewLink?: string;
    /** default subject */
    subject?: string;
    /** tags */
    tag?: string[];
    /** template name */
    templateName?: string;
}

/** Alias matching backend schema name */
export type FaxCoverPageTemplateReq = TFaxCoverPageTemplateReq;

/** R«FaxCoverPageTemplateVo» data field */
export interface FaxCoverPageTemplateVo {
    createAt?: string;
    /** Documo cover page UUID */
    documoCoverpageId?: string;
    /** template ID */
    id?: number;
    /** whether default template */
    isDefault?: boolean;
    /** default note content */
    note?: string;
    /** cover page preview link */
    previewLink?: string;
    /** default subject */
    subject?: string;
    /** tags */
    tag?: string[];
    /** template name */
    templateName?: string;
    updateAt?: string;
}

export interface CoverSheetTemplate {
    id: string;
    name: string;
    subject?: string;
    /** Default note / remarks (from API) — used when opening edit modal */
    note?: string;
    /** Documo layout id for template picker on edit */
    documoCoverpageId?: string;
    tag?: string;
    lastModified: string;
    thumbnailUrl?: string;
}

export type DashboardTab = 'received' | 'sent' | 'contacts' | 'templates';

export const CONTACT_TAG_OPTIONS = [
    'Lab',
    'Pharmacy',
    'Provider',
    'Clinical Notes',
    'Labs & Imaging',
    'Referral',
    'General',
];

export const FAX_TAG_OPTIONS = [
    'Lab Results',
    'Prior Authorizations',
    'Medical Records',
    'Disability / Work Forms',
    'Consult Notes',
];

// API request/response types

export interface TGetFaxHistory {
    tag?: string;
    status?: string;
    limit?: number;
    offset?: number;
}

export interface TSearchNumbers {
    state: string;
    areaCode?: string;
    limit?: number;
}

export interface TProvisionNumber {
    numbers: string;
    providerId: number;
}

export interface TSendFax {
    faxNumber: string;
    recipientName?: string;
    senderName?: string;
    subject?: string;
    callerId?: string;
    coverPage?: boolean;
    notes?: string;
    tags?: string;
    file: File;
}

export interface TResendFax {
    recipientFax?: string;
}

// {
//     "providerId": 1,
//     "faxNumber": "19172034869",
//     "source": "new",
//     "status": "active",
//     "boundAt": "2026-03-03T23:49:51.000Z"
//     }

export interface TProviderFaxNumber {
    providerId: number;
    /** E.164 / raw number for APIs & copy */
    faxNumber: string;
    /** Human-readable, e.g. (480) 319-7943 — from provision response */
    faxNumberDisplay?: string;
    source: string;
    status: string;
    boundAt: string;
}

/** GET /schedule-server/fax/number/search */
export interface TFaxScheduleSearchParams {
    state: string;
    areaCode?: string;
}

export interface FaxRegionalData {
    countryIso?: string;
    rateCenter?: string;
    state?: string;
}

export interface FaxAvailableNumber {
    city?: string;
    country?: string;
    monthlyFee?: number;
    number?: string;
    preferable?: boolean;
    price?: number;
    regionalData?: FaxRegionalData;
    state?: string;
}

/** POST /schedule-server/fax/number/provision — type: order | forwarded | create */
export interface TFaxProvisionReq {
    number: string;
    type?: string;
}

export interface FaxAccountVo {
    efaxAccountId: number;
    faxNumber: string;
    faxNumberDisplay: string;
    status: string;
}

/** GET /schedule-server/fax/number/status -> data */
export interface FaxNumberStatusVo {
    activeAccount?: FaxAccountVo;
    hasCancelledAccount?: boolean;
    pendingPortFaxNumber?: string;
}

/** Persisted after successful POST /fax/number/provision until profile API returns the number */
export const EFAX_PROVISION_SESSION_KEY = 'klarity_efax_provision';

/** POST /schedule-server/fax/inbox/list */
export interface TFaxInboxListQuery {
    aiSummary?: string;
    /** Page index, 1-based */
    current?: number;
    orderKey?: string;
    orderType?: string;
    patientName?: string;
    sendFrom?: string;
    size?: number;
    /** e.g. RECEIVED_ON */
    sortBy?: string;
    tags?: string[];
}

/** POST /schedule-server/fax/sent/list */
export interface TFaxSentListQuery {
    current?: number;
    orderKey?: string;
    orderType?: string;
    patientName?: string;
    sendTo?: string;
    size?: number;
    /** e.g. SEND_ON */
    sortBy?: string;
    status?: string[];
    subject?: string;
    tags?: string[];
}

export interface FaxAssignedClient {
    clientId?: number;
    name?: string;
}

export interface VendorDocumoEfaxContactVo {
    createAt?: string;
    createBy?: number;
    faxNumber?: string;
    faxNumberDisplay?: string;
    id?: number;
    isFavorite?: boolean;
    name?: string;
    notes?: string;
    providerId?: number;
    status?: string;
    tag?: string;
    updateAt?: string;
    updateBy?: number;
}

export interface FaxMessageVo {
    aiSummary?: string;
    assignedClient?: FaxAssignedClient;
    completedAt?: string;
    contact?: VendorDocumoEfaxContactVo;
    createAt?: string;
    direction?: string;
    hasAttachment?: boolean;
    isRead?: boolean;
    pages?: number;
    patientMatchSource?: string;
    patientMatchStatus?: string;
    recipientEmail?: string;
    recipientFax?: string;
    recipientName?: string;
    senderFax?: string;
    senderName?: string;
    sentAt?: string;
    status?: string;
    subject?: string;
    tag?: string[];
    uuid?: string;
}

export interface TFaxPagedMessages {
    isLast: boolean;
    list: FaxMessageVo[];
    pageNo: number;
    pageSize: number;
    totalRecords: number;
}

/** Normalized row for eFax inbox/sent tables (schedule FaxMessageVo or legacy history). */
export interface EFaxListRow {
    id: string;
    faxCallerId: string;
    faxNumber: string;
    faxCsid?: string;
    /** Contact name from API response (contact.name), distinct from senderName */
    contactName?: string;
    users?: FaxHistoryItem['users'];
    subject?: string | null;
    status: string;
    tag?: string;
    aiSummary?: string;
    patient?: string;
    /** Numeric clientId for patient assignment API calls */
    patientId?: number;
    createdAt: string;
    /** Schedule inbox: drives unread dot when set */
    isRead?: boolean;
    /** Whether the patient was AI-matched (patientMatchSource === 'AI') */
    aiMatched?: boolean;
}

/** POST /schedule-server/fax/number/port-in (multipart/form-data) */
export interface TFaxPortInReq {
    authorizedPerson?: string;
    billingTelephoneNumber?: string;
    carrierAccountNumber?: string;
    endUserCity?: string;
    endUserName?: string;
    endUserPostalCode?: string;
    endUserState?: string;
    faxNumber?: string;
    /** Letter of Authorization file */
    loaFile: File;
    pinPasscode?: string;
    /** Practice address street line */
    practiceAddress?: string;
    /** Recent carrier bill file */
    recentBillFile: File;
}

/** File upload metadata (R«FileUpload» data field). */
export interface FileUpload {
    /** Backend may return this id as `fileUploadId` or `id` depending on gateway mapping. */
    fileUploadId?: number;
    id?: number;
    fileExtension?: string;
    fileOriginName?: string;
    fileS3Bucket?: string;
    fileSize?: number;
    fileType?: string;
    fileUri?: string;
    isPublic?: boolean;
    status?: string;
    uploadedUserId?: number;
    uploadedUserType?: string;
}

/** POST /schedule-server/fax/number/port-in (application/json) — port-in using uploaded file ids. */
export interface TFaxPortInSubmitReq {
    authorizedPerson?: string;
    billingTelephoneNumber?: string;
    carrierAccountNumber?: string;
    endUserCity?: string;
    endUserName?: string;
    endUserPostalCode?: string;
    endUserState?: string;
    faxNumber?: string;
    loaFileUploadId: number;
    pinPasscode?: string;
    practiceAddress?: string;
    recentBillFileUploadId: number;
}

/** R«FaxPortOrderVo» data field */
export interface FaxPortOrderVo {
    portOrderId?: number;
    faxNumber?: string;
    status?: string;
}

/** FaxMessageDetailVo — GET /fax/{uuid} response data */
export interface FaxMessageDetailVo {
    uuid?: string;
    direction?: string;
    status?: string;
    subject?: string | null;
    notes?: string | null;
    tag?: string[];
    senderFax?: string;
    senderName?: string | null;
    recipientFax?: string;
    recipientName?: string | null;
    recipientEmail?: string | null;
    pages?: number;
    duration?: number;
    sentAt?: string;
    completedAt?: string;
    isRead?: boolean;
    aiSummary?: string | null;
    assignedClient?: FaxAssignedClient;
    contact?: VendorDocumoEfaxContactVo;
    attachments?: { url?: string; name?: string }[];
    createAt?: string;
}

/** CoverPageResponse — GET /fax/cover-page-template/documo-list item */
export interface CoverPageResponse {
    id?: number;
    name?: string;
    uuid?: string;
    previewLink?: string;
    previewUrl?: string;
    fileId?: string;
    accountId?: string;
    userId?: string;
    isPublic?: boolean;
    inherit?: boolean;
    /** HTML string for rendering template preview (Documo) */
    template?: string | Record<string, unknown>;
    file?: Record<string, unknown>;
}

/** POST /fax/cover-page-template/list request */
export interface TFaxCoverPageTemplateListQuery {
    current?: number;
    size?: number;
    name?: string;
    tag?: string[];
    orderKey?: string;
    orderType?: string;
}

/** POST /fax/send — `req` JSON (all fields except `files`) + multipart `files` */
export interface TFaxSendParams {
    clientId?: number;
    contactId?: number;
    coverPage?: boolean;
    coverPageTemplateId?: number;
    documentIds?: number[];
    notes?: string;
    recipientEmail?: string;
    recipientFax?: string;
    recipientName?: string;
    /**
     * DIRECT — uploaded `files`; DOCUMENT — `documentIds` (client chart PDFs);
     * INTAKE — intake PDF from `sourceId`; TREATMENT_PLAN — per server contract.
     */
    source?: string;
    sourceId?: number;
    /** When `source` is INTAKE (e.g. TEXT_VISIT). Null / omit for DOCUMENT or DIRECT. */
    intakeBusinessType?: string | null;
    subject?: string;
    tag?: string[];
    /** files — optional FormData files for source=DIRECT */
    files?: File[];
}

/** POST /schedule-server/provider/channel/stripe/unifiedPay */
export interface TStripeUnifiedPayReq {
    country?: string;
    couponId?: string;
    email?: string;
    key?: string;
    paymentMethodId?: string;
    postalCode?: string;
    /** KIWI_PORTAL | KLARITY_PORTAL */
    providerType?: string;
    type?: string;
}
